import {escapeHtmlSymbols} from "../atUtils"
import $ from "jquery"
import _ from "underscore"

export function splitToLines(str, limit, delimiter, partsLimit, ellipsis, recursively) {
    if (str.length < limit)
        return [str];

    var indices = [];
    for (var i = 0; i < str.length; i++) {
        if (str[i] === delimiter) indices.push(i);
    }
    if (indices.length == 0) {
        return [str.substr(0, partsLimit - ellipsis.length) + ellipsis];
    }
    //lets find delimiter which is the closest one to string's middle!
    var stringMiddle = str.length / 2;
    var closest = indices[0];
    $.each(indices, function(i, item) {
        if (Math.abs(item - stringMiddle) < Math.abs(closest - stringMiddle)) {
            closest = item;
        }
    });
    var part1 = str.substr(0, closest).trim();
    var parts1 = part1.length > partsLimit ? (recursively ? splitToLines(part1, limit, delimiter, partsLimit, ellipsis, true) : [
        part1.substr(0, partsLimit) + (ellipsis ? ellipsis : "")
    ]) : [part1];
    var part2 = str.substr(closest).trim();
    var parts2 = part2.length > partsLimit ? (recursively ? splitToLines(part2, limit, delimiter, partsLimit, ellipsis, true) : [
        part2.substr(0, partsLimit) + (ellipsis ? ellipsis : "")
    ]) : [part2];
    return $.merge(parts1, parts2);
}

export function insertBrakes(str, limit, delimiter, partsLimit, ellipsis, escape, recursively) {
    var parts = splitToLines(str, limit, delimiter, partsLimit, ellipsis, recursively);
    var result = escape ? escapeHtmlSymbols(parts[0]) : parts[0];
    for (var i = 1; i < parts.length; i++) {
        result += "<br>" + (escape ? escapeHtmlSymbols(parts[i]) : parts[i])
    }
    return result;
}

export function convertLineBreaksToBR( str )
{
    return str.replace(/\n/g, "<br>");
}

export function cutLongText(str, maxLen) {
    if (str && str.length > maxLen) {
        return str.substr(0, maxLen - 3) + '...';
    }
    return str;
}

/**
 * Method detect new line symbol and count lines. If number of lines more than limit - cut remaining text
 * @param str string for cut
 * @param maxLines number of lines
 * @returns {string} cut sting
 */
export function cutNumberOfTextLines(str, maxLines) {
    var newLine = '\n';
    var lineCount = 0;
    var charCount;
    var needToLimitStr = false;
    for (charCount = 0; charCount < str.length; charCount++) {
        var currentChar = str[charCount];
        if (currentChar == newLine) {
            lineCount++
        }
        if (lineCount >= maxLines) {
            needToLimitStr = true;
            break;
        }
    }
    if (needToLimitStr) {
        return str.substr(0, charCount) + "\n...";
    }
    return str
}

/**
 * @param str (could be null or undefined)
 * @returns {boolean} is string not empty
 */
export function isNotEmptyString(str) {
    return _.isString(str) && str.length > 0;
}

export function isNullOrBlank(str) {
    return !str || _.isEmpty(str.trim())
}


// WEBPACK FOOTER //
// ./web/js/util/StringUtils.js